import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=424c3038&"
import script from "./Fees.vue?vue&type=script&lang=js&"
export * from "./Fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424c3038')) {
      api.createRecord('424c3038', component.options)
    } else {
      api.reload('424c3038', component.options)
    }
    module.hot.accept("./Fees.vue?vue&type=template&id=424c3038&", function () {
      api.rerender('424c3038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Fees.vue"
export default component.exports